/*jshint esversion: 6 */
"use strict";

import Vue from 'vue';
// import VueResource from 'vue-resource';
// Vue.use(VueResource);

import RecordRTC from "recordrtc";
// import { RecordRTCPromisesHandler } from "recordrtc";
// import RecordRTC from "/code/s/staticlib/recordrtc/recordRTC.js";
// require("/code/s/staticlib/recordrtc/adapter-latest.js");
var tus = require('../modules/tus-pack.js');

import videojs from 'video.js';
import playerjs from 'player.js';
// import videojs from '/code/s/staticlib/videojs/video.js';
// //require('/code/s/staticlib/videojs/videojs-markers-pack.js');

// import playerjs from '/code/s/staticlib/embedlyplayerjs/player-0.0.12.min.js';
import env from "../utils/env.js";
import ivbus from "@/utils/ivbus.js";

//$(document).ready(function(){

var recorder = null;

export var ivRecordClientMixin = {
    data: function () {
        return {
            recorder: null,
            state: "ready",
            originalVideoUploadProgress: null,
            currentUpload: null,
        };
    },
    mounted: function () {
        var that = this;
        window.addEventListener("pagehide", function () {
            if (that.originalVideoUploadProgress && that.originalVideoUploadProgress < 100) {
                return "Hold on a moment!";
            }
        });

        // var pmal = {
        //     meta: {
        //         type: "record",
        //         token: that.token
        //     },
        //     logs: []
        // }

        // var clog = console.log;
        // console.log = function (text) {
        //     clog(text);
        //     pmal.logs.push("[LOG] " + text);
        // }

        // var cinfo = console.info;
        // console.info = function (text) {
        //     cinfo(text);
        //     pmal.logs.push("[INFO] " + text);
        // }

        // var cwarn = console.warn;
        // console.warn = function (text) {
        //     cwarn(text);
        //     pmal.logs.push("[WARN] " + text);
        // }

        // var cerror = console.error;
        // console.error = function (text) {
        //     cerror(text);
        //     pmal.logs.push("[ERROR] " + text);
        // }

        // var postPmal = function () {
        //     if (pmal.logs.length > 0) {
        //         pmal.meta.token = that.token;
        //         that.$http.post("/api/pmal/log/?t=" + that.token, pmal);
        //         pmal.logs = [];
        //     }
        //     setTimeout(postPmal, 60000);
        // }

        // setTimeout(postPmal, 60000);

        // and window.sendBeacon

    },
    beforeDestroy: function () {

    },
    methods: {
        ////Save to local disk
        // saveData: function() {
        //     var a = document.createElement("a");
        //     document.body.appendChild(a);
        //     a.style = "display: none";
        //     return function (data, fileName) {
        //         a.href = data;
        //         a.download = fileName;
        //         a.click();
        //     };
        // },
        cleanup: function () {
            recorder.destroy();
            recorder = null;
        },
        chunkUploadRecording: function (endpoint, file, context, progressBar, callback, errorCb) {
            console.log('inside chunkUpload');
            var that = this;
            Vue.set(context, progressBar, true);
            var upload = new tus.Upload(file, {
                endpoint: endpoint,
                metadata: {
                    token: sessionStorage.apitoken || that.upload_token,
                    filename: file.name || "recording.webm"
                },
                retryDelays: [0, 1000, 3000, 5000],
                chunkSize: 1000 * 1024, // 1MB
                onError: function (error) {
                    typeof errorCb === "function" ? errorCb(error) : "";
                },
                onProgress: function (bytesUploaded, bytesTotal) {
                    var splitted = upload.url.split('/');
                    var resource_id = splitted[splitted.length - 1];
                    that.video_file_uid = resource_id;
                    var percentage = (bytesUploaded / bytesTotal * 100).toFixed(2);
                    // console.log("progress: ", bytesUploaded, bytesTotal, percentage + "%");
                    // Vue.set(that, progressBar, percentage);
                },
                onChunkComplete: function (chunkSize, bytesAccepted, bytesTotal) {
                    var percentage = (bytesAccepted / bytesTotal * 100).toFixed(0);
                    Vue.set(context, progressBar, percentage);
                },
                onSuccess: function () {
                    var splitted = upload.url.split('/');
                    var resource_id = splitted[splitted.length - 1];
                    callback(resource_id);
                }
            });
            upload.start();
        },
        uploadVideoRecording: function () {
            console.log("uploadRecording called");
            var that = this;
            var originalVideoUploadProgress = null;
            var currentUpload = this.currentUpload = Date.now();

            this.chunkUploadRecording(env.serverAddr + "/tus_files/", recorder.getBlob(), this, "originalVideoUploadProgress", function (resource_id) {
                console.log("success");

                if (currentUpload == that.currentUpload) {
                    ivbus.$emit('videoRecordingUploadComplete', resource_id);
                }

            }, function (error) {
                console.log("fail");
            });
        },

        recordingVideoStart: function (cameraStream) {
            var that = this;
            this.state = "recording";

            if (that.camera) {
                //recorder settings based on extensive tests using 2017 macbook pro webcam
                //objective of these optimizations: decrease file size while preserving close to original quality
                // recorder = RecordRTC(cameraStream, {
                //     recorderType: RecordRTC.MediaStreamRecorder,
                //     mimeType: 'video/webm',
                //     audioBitsPerSecond: 20000,
                //     videoBitsPerSecond: 700000,
                //     video: {
                //         width: 480,
                //         height: 268
                //     }
                // });
                recorder = new RecordRTC(cameraStream, {
                    type: "video",
                    mimeType: "video/webm;codecs=h264",

                    audioBitsPerSecond: 256 * 8 * 1024, // 250KBps or 2Mbps
                    numberOfAudioChannels: 2,
                    videoBitsPerSecond: 256 * 8 * 1024, // 250KBps or 2Mbps
                    video: {
                        width: 640,
                        height: 360,
                    },
                });
                recorder.startRecording();
                // release camera on stopRecording
                recorder.camera = that.camera;
            } else {
                // start camera then call recordingStart again
            }

        },
        recordingVideoStop: function (cb) {
            this.state = "done";
            recorder.stopRecording(cb);
        },

        previewRecording: function (videoUrl, audioUrl) {

            var p = this;
            p.customid = "playback";

            if (p.myPlayer) {
                p.myPlayer.reset();
                var source = "";
                p.myPlayer.src(source = {
                    src: recorder ? recorder.toURL() : videoUrl,
                    type: 'video/mp4'
                }); // 
                p.myPlayer.load();
                return;
            }

            p.myPlayer = videojs(p.customid, {
                "controls": true,
                "autoplay": false,
                "aspectRatio": "480:268",
                "controlBar": {
                    "volumePanel": {
                        "inline": false,
                    },
                    "pictureInPictureToggle": false
                }
            }, function () {
                var adapter = new playerjs.VideoJSAdapter(this);
                adapter.ready();
            });

            p.myPlayer.ready(function () {

                var source = "";

                p.myPlayer.src(source = {
                    src: recorder ? recorder.toURL() : videoUrl,
                    type: 'video/mp4'
                }); // 

                p.myPlayer.load();

                p.myPlayer.on('play', function () {
                    $('#' + p.customid + ' .vjs-big-play-button').css('display', 'none');
                });

                p.myPlayer.on('pause', function () {
                    $('#' + p.customid + ' .vjs-big-play-button').css('display', 'block');
                });

                p.myPlayer.on('ended', function () {
                    $("#my-player").remove();
                });

                p.myPlayer.on('error', function (e) {
                    console.log(e);
                    p.displayNotFound();
                });

                var domain = window.location.origin;

                $('<button id="back-10s-btn-' + p.customid + '" class="back-10s-btn vjs-control vjs-button" type="button" aria-live="polite" title="Rewind 10 Seconds"><span class="vjs-control-text">Rewind 10 Seconds</span><img class="back-ten-seconds" src="data:image/png;base64,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"</button>').insertAfter("#" + p.customid + " .vjs-control-bar .vjs-play-control");
                $("#" + p.customid + " .vjs-control-bar .back-ten-seconds").click(function () {
                    var c = p.myPlayer.currentTime();
                    p.myPlayer.currentTime(c - 10);
                    p.myPlayer.play();
                });

                $('<button id="skip-10s-btn-' + p.customid + '" class="skip-10s-btn vjs-control vjs-button" type="button" aria-live="polite" title="Skip 10 Seconds"><span class="vjs-control-text">Skip 10 Seconds</span><img class="skip-ten-seconds" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IB2cksfwAAAARnQU1BAACxjwv8YQUAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+oJBAAWFP87BsgAAAQZSURBVDjLdZTfa1xFFMe/Z7K/kv2RWGmyNdtYSxQpKEgpfWgLIlUwRWuRFaEUC7ZYKQX/hRbqm4K0xRfBp4IYihaxSBWsELGlBnwKhkazbOfO3Jvd7DW9mzT7487XB3fDWvS8zTkzn5lzvnMO8IjNzs4OkRwa9Hme95a5b14PvOAl3/f39ffhP0wGFySHRCQGAK31ZFKSLzi4JxzcKSVqJ4ivSY46uE9KpdIdkkpE3CAj0QPJhQsXRETiIAieiuP4fZLHJCHThWwBaw/WkMvn0Iyah0TJd+Lkktb6uIjc62XDPlhICgCICI0xbwvl4thjY7vXHqwhjuO7IvIjgIMAdonIdedcieSXk5OTX0AQC4T/ypikAgBjzFlrLaMoojHmptZ6ZnFxMd+LHbZVe9AYc9j3/RcB4DzOKwCoVCqZarW6l2R6C+trf8YYs9lYbdB69qN+sCdQZrDGALCwsJACgFnODhljLhljQmPMUQDA8vLyhPXs7YcbD2mM+WxQ7UFQP5OeKQCYn59PGmOuttttep53u1KpFKG1Ph2GIY0x97TW04OKBUGwv9Fo7NzKxPf3BUHw7qpenez7Vqoru40xi2EYUmt9WimoI8lEEgCulUqlJQAIw3A0CIKPReQb13EHAGBlZeU4gMsg3ugkOleDIHgOAManxv8E8FUykYRS6oiCYE/UjGLn3N3+rZ1OZx8cJkj+RTKztLSUJvmBUmp2ojjxGoANEXlvS1qRO1EUxQD2KAiKIKKEJBr9umzfvv2n8eL4OyR1l91UoVAogRgG8FuP8atz7klr7QgAxHEcEoxAlJRA1iFIUjEFAKOjo0pEOiLSFREqqqjdbocEtxQXkVEArbm5uRYAKKWSSlRCRCJFcjmTzmQZ82kAmJ6ebtVqtVytVvvnMys5lM1mYwC/gDjj+34ZxCskb26pF+OZVDqVA7CkQMyl02mIyKu1Wi0HAN1ud1scx8cA3CU5trm5+byInHN0f4jIKYJXisXi5+VyOa7X63kqzmTSGRD8GVrr/caYRhAE9DzvBABYa0fq9XqeZFJrPay1Hu4/pl6v5wHg1q1bid4kOuH7Po0xDa31fvQAF9fX12k8c79arR4c7AqSQlIWFhZSJBP93u+15AHjmfsb6xu01n64VYJKpTJmPfttq9WitdZ4nneyUqlk8D+mtR72PO+k9axptVr0PO9GGIZj/WkzJCKx1npSQV3JFXJHO+0OWq3WDwSvOefmATR6rG1Kqb0CeTOdTh9OppJoNpvXnXNnS6WSR3JI+n1bLpdja+0IHM5AcC5fyO+iI5rN5gaA1R7w8WwuO6KUQhRFFefcZaXUpzt27NjoD1sZHAblcjkGgGq1ujuhEjNQeBnAswIpAQBBDeB3OHzfdd0bU1NTfz569m+UFI7JfAvCHQAAAABJRU5ErkJggg=="</button>').insertAfter("#" + p.customid + " .vjs-control-bar #back-10s-btn-" + p.customid);
                $("#" + p.customid + " .vjs-control-bar .skip-ten-seconds").click(function () {
                    var c = p.myPlayer.currentTime();
                    p.myPlayer.currentTime(c + 10);
                    p.myPlayer.play();
                });

                $("#" + p.customid + " .vjs-control-bar .vjs-volume-panel").insertBefore("#" + p.customid + " .vjs-control-bar .vjs-fullscreen-control");

                if (p.embedded) {
                    var link = window.location.href.replace(/\/embed/, "");
                    $('<a target="_blank" id="open-iv-btn" href="' + link + '" title="Open in InitialView" class="vjs-control vjs-button" type="button" aria-live="polite"><span class="vjs-control-text">Open in InitialView</span><img class="iv-icon" src="' + domain + '/s/img/_shared/favicon.png"</button>').insertBefore("#" + p.customid + " .vjs-control-bar .vjs-fullscreen-control");
                }

                $("#" + p.customid + " .vjs-control-bar .vjs-fullscreen-control").remove();

                $(".video-js").on("touchstart", function () {
                    if (p.myPlayer.paused()) {
                        p.myPlayer.play();
                    } else {
                        p.myPlayer.pause();
                    }
                });

                p.readyToPlay = true;
                p.myPlayer.play(); //autoplay!
            });

        },

    }
};
//});